module.exports = __webpack_public_path__ + "static/media/IMG_0087-2.71aea8d7.jpg";